import { PAGE_PREVIEW_KIND, PAGE_ROUTE_NAMES } from "@/apps/page/page.routes";

function createActionPayload(name, data) {
    return { action: { name, data } };
}

export function useEditorActions() {
    function postMessageToParent(payload) {
        window.parent.postMessage(payload, "*");
    }

    function createRoutePayload(query) {
        return {
            setRoute: {
                name: PAGE_ROUTE_NAMES.projectSections,
                query: {
                    view: PAGE_PREVIEW_KIND.page,
                    ...query,
                },
            },
        };
    }

    return {
        editBlockElement(blockId, fieldName) {
            postMessageToParent(
                createRoutePayload({
                    field: fieldName,
                    open: "editBlock",
                    id: blockId,
                })
            );
        },
        hideBlockElement(blockId, fieldName) {
            postMessageToParent(createActionPayload("hideBlockElement", { blockId, fieldName }));
        },
        magicallyExchangeContent(blockId, fieldName) {
            postMessageToParent(
                createActionPayload("magicallyExchangeContent", { blockId, fieldName })
            );
        },
        editSection(sectionId) {
            postMessageToParent(
                createRoutePayload({
                    open: "editSection",
                    id: sectionId,
                })
            );
        },
        moveSection(sectionId, direction) {
            postMessageToParent(createActionPayload("moveSection", { sectionId, direction }));
        },
        addSection() {
            postMessageToParent(
                createRoutePayload({
                    open: "addSection",
                })
            );
        },
        hideSection(sectionId) {
            postMessageToParent(createActionPayload("hideSection", sectionId));
        },
        removeSection(sectionId) {
            postMessageToParent(createActionPayload("removeSection", sectionId));
        },
        setOrderSections(sectionIds) {
            postMessageToParent(createActionPayload("setOrderSections", sectionIds));
        },
        createBlock(block) {
            postMessageToParent(createActionPayload("createBlock", block));
        },
        createToolSection(project) {
            postMessageToParent(createActionPayload("createToolSection", project));
        },
        createToolProject(projectData) {
            postMessageToParent(createActionPayload("createToolProject", projectData));
        },
        publishToolProject(projectData) {
            postMessageToParent(createActionPayload("publishToolProject", projectData));
        },
        async connectToolSectionWithProject(data) {
            postMessageToParent(createActionPayload("connectToolSectionWithProject", data));
            return "";
        },
        async bindToolSectionWithProject(data) {
            postMessageToParent(createActionPayload("bindToolSectionWithProject", data));
        },
    };
}
